import { convertNumber, useApi, useToggle } from "utils"
import { AdjustmentInventoryType } from "../utils"
import { Controller, useFormContext, useWatch } from "react-hook-form"
import { Fragment, useContext, useEffect, useRef, useState } from "react"
import { AccountModal, BaseTable, Button, Card, NumberInput, Select, TableHeader } from "components"
import { PropsValue } from "react-select"
import { IoMdClose } from "react-icons/io";
import { Item } from "./Item"
import { LinkAccountContext } from "../contexts"
import toast from "react-hot-toast"
import { useAdjustmentStore } from "../store/adjusmentInventoryStore"

export function TableSection(props: {
  isEdit?: boolean,
}) {
 const { setListAvailable } = useAdjustmentStore()
  const { watch, setValue } = useFormContext<AdjustmentInventoryType>()
  const adjusmentDetail = watch("adjusmentDetail")
  
  useEffect(() => {
    setListAvailable(adjusmentDetail.length > 0)
    // eslint-disable-next-line
  }, [adjusmentDetail, setListAvailable])

  return (
    <Card>
      <Card.Body className="flex flex-col gap-3">
        <div className="my-3">
          <Item />
        </div>
        <div className="text-xl font-bold">LIST ITEM ADJUSTMENT</div>
        <div className="overflow-x-auto">
          <BaseTable>
            <TableHeader>
              <tr>
                <th rowSpan={2}>#</th>
                <th rowSpan={2}>ITEM</th>
                <th rowSpan={2}>DESCRIPTION</th>
                <th rowSpan={2}>UNIT</th>
                <th rowSpan={2}>SOH</th>
                <th rowSpan={2}>STOCK IN</th>
                <th rowSpan={2}>STOCK OUT</th>
                <th colSpan={2}>RECAP IN CONVERTION UNIT</th>
                <th rowSpan={2}>AVERAGE UNIT PRICE</th>
                <th rowSpan={2}>AMOUNT ADJUSTMENT</th>
                <th rowSpan={2}>POSITION</th>
                <th rowSpan={2}>COA INVENTORY</th>
                <th rowSpan={2}>COA EXPENCES/COGS</th>
                <th rowSpan={2}>ACTION</th>
              </tr>

              <tr>
                <th>IN</th>
                <th>OUT</th>
              </tr>
            </TableHeader>

            <tbody>
              {adjusmentDetail.length > 0 ? (
                adjusmentDetail.map((data, key) => {

                  const stockIn = watch(`adjusmentDetail.${key}.stock_in`)
                  const stockOut = watch(`adjusmentDetail.${key}.stock_out`)
                  const differntUnit = watch(`adjusmentDetail.${key}.different_unit`)
                  const amountAdjustment = watch(`adjusmentDetail.${key}.amount_adjustment`)
                  const position = watch(`adjusmentDetail.${key}.position`)


                  return (
                    <Fragment>
                      <tr>
                        <td>{key + 1}</td>
                        <td>{data.product_barcode}</td>
                        <td>{data.product_name}</td>
                        <td>{data.mr_unit_name}</td>
                        <td className="text-right">{data.soh ? convertNumber(data.soh).intoCurrency : 0}</td>

                        <StockInOut
                          index={key}
                        />
                        <td className="text-right">{stockIn && differntUnit ? `${convertNumber(differntUnit).intoNormalAmount} ${data.unit_convention_name}` : 0}</td>
                        <td className="text-right">{stockOut && differntUnit ? `${convertNumber(differntUnit).intoNormalAmount} ${data.unit_convention_name}` : 0}</td>
                        <td className="text-right">{data.avg_price_use ? convertNumber(Number(data.avg_price_use)).intoCurrency : 0}</td>
                        <td className="text-right">{amountAdjustment ? convertNumber(amountAdjustment).intoCurrency : 0}</td>
                        <td className="uppercase">{position === 1 ? "DEBET" : (position === 2 ? "CREDIT" : "")}</td>

                        <CoaDropDown
                          index={key}
                          isEdit={props.isEdit}
                        />

                        <td>

                          {data.adjustment_detail_id ? (
                            <DeleteItem id={data.adjustment_detail_id} />
                          ) : (
                            <Button
                              type="button"
                              color="ghost"
                              onClick={() => {
                                const adjusmentDetail = watch("adjusmentDetail")
                                adjusmentDetail.splice(key, 1)
                                setValue("adjusmentDetail", adjusmentDetail)
                              }}
                            >
                              <IoMdClose className="text-red-500 text-lg" />
                            </Button>
                          )}

                        </td>
                      </tr>
                    </Fragment>
                  )
                })
              ) : (
                <tr>
                  <td colSpan={15} className="text-center">No data available</td>
                </tr>
              )}
            </tbody>

          </BaseTable>
        </div>
      </Card.Body>
    </Card>
  )
}

function CoaDropDown(params: {
  index: number
  isEdit?: boolean
}): JSX.Element {
  const { isActive, toggle } = useToggle(false)
  const [selectedField, setSelectedField] = useState<"coa_inventory_id" | "coa_coex_id" | null>(null)
  const { control, watch, setValue } = useFormContext<AdjustmentInventoryType>()
  const { data: coa } = useContext(LinkAccountContext)

  const stockIn = watch(`adjusmentDetail.${params.index}.stock_in`)
  const stockOut = watch(`adjusmentDetail.${params.index}.stock_out`)


  // default coa
  const defaultCoaCoex = useRef({
    id: watch(`adjusmentDetail.${params.index}.coa_coex_id`),
    code: watch(`adjusmentDetail.${params.index}.coa_coex_code`),
    name: watch(`adjusmentDetail.${params.index}.coa_coex_name`),
  });


  useEffect(() => {
    if (Number(stockOut) > 0) {
      setValue(`adjusmentDetail.${params.index}.coa_coex_id`, Number(coa?.coa_id))
      setValue(`adjusmentDetail.${params.index}.coa_coex_code`, coa?.coa_code!)
      setValue(`adjusmentDetail.${params.index}.coa_coex_name`, coa?.coa_name!)
    } else {
      setValue(`adjusmentDetail.${params.index}.coa_coex_id`, defaultCoaCoex.current.id)
      setValue(`adjusmentDetail.${params.index}.coa_coex_code`, defaultCoaCoex.current.code)
      setValue(`adjusmentDetail.${params.index}.coa_coex_name`, defaultCoaCoex.current.name)
    }

    // eslint-disable-next-line
  }, [stockIn, stockOut, coa])


  const coaInventoryName = `${watch(`adjusmentDetail.${params.index}.coa_inventory_code`)} - ${watch(`adjusmentDetail.${params.index}.coa_inventory_name`)}`

  const coaCoexName = `${watch(`adjusmentDetail.${params.index}.coa_coex_code`)} - ${watch(`adjusmentDetail.${params.index}.coa_coex_name`)}`

  return (
    <>
      <td>
        <Controller
          name={`adjusmentDetail.${params.index}.coa_inventory_id`}
          control={control}
          render={({ field, fieldState }) => {

            let value: PropsValue<{
              value: string
              label: string
            }> = null

            if (field.value) {
              value = {
                label: coaInventoryName,
                value: field.value.toString()
              }
            }

            return (
              <section onClick={() => {
                setSelectedField("coa_inventory_id")
                toggle()
              }}>
                <Select
                  placeholder="Select Account"
                  error={fieldState.error?.message}
                  ref={field.ref}
                  value={value}
                  className="w-[200px]"

                />
              </section>
            )
          }}
        />
      </td>
      <td>
        <Controller
          name={`adjusmentDetail.${params.index}.coa_coex_id`}
          control={control}
          render={({ field, fieldState }) => {


            let value: PropsValue<{
              value: string
              label: string
            }> = null

            if (field.value) {
              value = {
                label: coaCoexName,
                value: field.value.toString()
              }
            }

            return (
              <section onClick={() => {
                setSelectedField("coa_coex_id")
                toggle()
              }}>
                <Select
                  placeholder="Select Account"
                  error={fieldState.error?.message}
                  ref={field.ref}
                  value={value}
                  className="w-[200px]"
                />
              </section>
            )
          }}
        />
      </td>


      {isActive && (
        <AccountModal
          defaultGroup="01"
          toggle={toggle}
          onChange={(value, label, coa) => {
            if (selectedField === "coa_coex_id") {
              setValue(`adjusmentDetail.${params.index}.coa_coex_id`, coa.coa_id)
              setValue(`adjusmentDetail.${params.index}.coa_coex_code`, coa.coa_code)
              setValue(`adjusmentDetail.${params.index}.coa_coex_name`, coa.coa_name)
            }

            if (selectedField === "coa_inventory_id") {
              setValue(`adjusmentDetail.${params.index}.coa_inventory_id`, coa.coa_id)
              setValue(`adjusmentDetail.${params.index}.coa_inventory_code`, coa.coa_code)
              setValue(`adjusmentDetail.${params.index}.coa_inventory_name`, coa.coa_name)
            }
          }}
        />
      )}
    </>
  )
}

function StockInOut(params: {
  index: number
}): JSX.Element {

  const { control, watch, setValue } = useFormContext<AdjustmentInventoryType>()

  return (
    <Fragment>
      <td>
        <Controller
          control={control}
          name={`adjusmentDetail.${params.index}.stock_in`}
          render={({ field, fieldState }) => (
            <NumberInput
              value={field.value ?? 0}
              onValueChange={value => {
                field.onChange(value.floatValue)

                const quantity_unit_sell_convention = (Number(watch(`adjusmentDetail.${params.index}.quantity_unit_sell_convention`)) !== 0)? Number(watch(`adjusmentDetail.${params.index}.quantity_unit_sell_convention`)):1
                const differentUnit = Number(value.floatValue) * quantity_unit_sell_convention
                const amountAdjusment = differentUnit * Number(watch(`adjusmentDetail.${params.index}.avg_price_use`))

                setValue(`adjusmentDetail.${params.index}.different_unit`, differentUnit)
                setValue(`adjusmentDetail.${params.index}.amount_adjustment`, Math.round(amountAdjusment))
                setValue(`adjusmentDetail.${params.index}.position`, 1)
                setValue(`adjusmentDetail.${params.index}.different_adjustment`, Number(value.floatValue))

              }}
              error={fieldState.error?.message}
              inputClass="w-[100px] text-right"
              disabled={Boolean(watch(`adjusmentDetail.${params.index}.stock_out`))}
            />
          )}
        />
      </td>

      <td >
        <Controller
          control={control}
          name={`adjusmentDetail.${params.index}.stock_out`}
          render={({ field, fieldState }) => (
            <NumberInput
              value={field.value ?? 0}
              onValueChange={value => {
                field.onChange(value.floatValue)

                const quantity_unit_sell_convention = (Number(watch(`adjusmentDetail.${params.index}.quantity_unit_sell_convention`)) !== 0)? Number(watch(`adjusmentDetail.${params.index}.quantity_unit_sell_convention`)):1
                const differentUnit = Number(value.floatValue) * quantity_unit_sell_convention
                const amountAdjusment = differentUnit * Number(watch(`adjusmentDetail.${params.index}.avg_price_use`))

                setValue(`adjusmentDetail.${params.index}.different_unit`, differentUnit)
                setValue(`adjusmentDetail.${params.index}.amount_adjustment`, Math.round(amountAdjusment))
                setValue(`adjusmentDetail.${params.index}.position`, 2)
                setValue(`adjusmentDetail.${params.index}.different_adjustment`, Number(value.floatValue))
              }}
              error={fieldState.error?.message}
              inputClass="w-[100px] text-right"
              disabled={Boolean(watch(`adjusmentDetail.${params.index}.stock_in`))}
            />
          )}
        />
      </td>

    </Fragment>
  )
}

function DeleteItem(props: {
  id: number
}) {
  const api = useApi()

  const { control, setValue } = useFormContext<AdjustmentInventoryType>()

  const data = useWatch({
    control,
    name: "adjusmentDetail"
  })



  const onDelete = async () => {
    try {
      await toast.promise(
        api.delete("/invadjustment/delete_item_adjustment", {
          params: { adjustment_detail_id: props.id }
        }),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message
        }
      );

      const newData = data.filter((item) => item.adjustment_detail_id !== props.id);
      setValue("adjusmentDetail", newData);

    } catch (error) {
      toast.error((error as Error).message)
    }
  };

return (
  <Button
    type="button"
    color="ghost"
    onClick={() => {
      onDelete()
    }}
  >
    <IoMdClose className="text-red-500 text-lg" />
  </Button>
)
}